export default __webpack_public_path__ + "static/media/01f_fold-6.fb8237dc.mp4";